import { DeviceRequestType, IdentifierRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * deviceOnSaveListData - Function that saves on database an list of devices 
 * /devices/list  
 * method POST  
 * @async-function
 */
const deviceOnSaveListData = async (token: string, list: Array<DeviceRequestType>) => {
    const response = await api.post(
        `/devices/list`, {
           list
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default deviceOnSaveListData;